export default "__VITE_PUBLIC_ASSET__39f067d4__"